export const serverLink = 'https://honest-years-kiss-34-142-176-15.loca.lt';

export const headers = {
    "Bypass-Tunnel-Reminder": 'true'
};